module.exports = __webpack_public_path__ + "static/media/photography-2-1.e7f1ac32.jpg";